import styled from 'styled-components';

const Content = styled.div`
  margin: auto;
`;

export default Content;
